import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../images/logo.webp';
import './Menu.css';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const Menu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('home');
  const [isLoading, setIsLoading] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navbarInfoRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const pathToTab = {
      '/': 'home',
      '/about': 'about',
      '/services': 'services',
      '/contact': 'contact',
    };
    setActiveTab(pathToTab[location.pathname]);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setMenuOpen(false);
  };

  const logoScale = Math.max(1 - scrollPosition / 200, 0.5);

  useEffect(() => {
    if (navbarInfoRef.current) {
      if (menuOpen) {
        navbarInfoRef.current.style.maxHeight = `${navbarInfoRef.current.scrollHeight}px`;
      } else {
        navbarInfoRef.current.style.maxHeight = '0px';
      }
    }
  }, [menuOpen]);

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="flex flex-wrap">
        <div className="w-full">
          <nav className="relative flex flex-wrap items-center justify-between px-2 py-2 lg:py-0">
            <div className="menu-container lg:px-20 w-full mx-auto flex flex-wrap items-center justify-between">
              <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                <Link
                  to="/"
                  className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-black"
                  onClick={() => handleTabClick('home')}
                >
                  <div
                    className="flex flex-wrap"
                    style={{
                      transform: `scale(${logoScale})`,
                      transition: 'transform 0.3s ease',
                    }}
                  >
                    <div className="font-Poppins m-auto">
                      <img src={logo} alt="Logo" className="w-20 h-20" />
                    </div>
                    <div className="flex-container mt-2">
                      <span className="text-l font-Poppins">
                        Digitale zahnpraxis{' '}
                      </span>
                      <span className="text-xl text-primary dancing-script">
                      <span className="text-lg text-primary dancing-script">
                        Dr.
                      </span> Hassan Alshoutaiui
                      </span>
                    </div>
                  </div>
                </Link>
                <button
                  className={`text-black cursor-pointer text-3xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none menu-button ${
                    menuOpen ? 'rotate-animation' : ''
                  }`}
                  type="button"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <i className="fas fa-bars text-primary"></i>
                </button>
              </div>

              <div
                className={`lg:flex flex-grow items-center transition-all duration-500 lg:pb-8 ${
                  menuOpen ? ' menu-open' : ' menu-hidden'
                }`}
                id="navbar-info"
                ref={navbarInfoRef}
              >
                <ul className="flex flex-col lg:flex-row list-none my-4 lg:mt-12 lg:ml-auto">
                  {[
                    { id: 'home', label: 'Home', path: '/' },
                    { id: 'about', label: 'Über Uns', path: '/about' },
                    { id: 'services', label: 'Leistungen', path: '/services' },
                    { id: 'contact', label: 'Kontakt', path: '/contact' },
                  ].map((tab) => (
                    <li
                      key={tab.id}
                      className={`nav-item ${
                        activeTab === tab.id ? 'active' : ''
                      }`}
                      onClick={() => handleTabClick(tab.id)}
                    >
                      <Link
                        to={tab.path}
                        className={`px-3 py-2 flex items-center text-md uppercase font-bold leading-snug text-black hover:opacity-75 ${
                          activeTab === tab.id ? 'text-primary' : ''
                        }`}
                      >
                        {tab.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Menu;